var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"align-content":"center"},attrs:{"id":"NavBar"}},[_c('v-breadcrumbs',{attrs:{"items":this.items,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return _c('v-breadcrumbs-item',{attrs:{"exact":"","to":item.to}},[_vm._v(" "+_vm._s(item.text)+" ")])}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }